import React, { useEffect, useState } from 'react';
import MaterialTable, { MTableBody } from '@material-table/core';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../../helpers/table';
import { getColumns, getFilters } from './tableKvrsHelper';
import MTableHeader from '../../../components/material-table-overrides/MTableHeader';
import MTableFilterRow from '../../../components/material-table-overrides/MTableFilterRow';
import './table.less';
import ProgramBuysFooter from './ProgramBuysFooter';

export default function ProgramBuysTableKvrs(props) {
  const { data, sourceType, reportType } = props;

  const [filters, setFilters] = useState({});

  useEffect(() => {
    setFilters(getFilters(data));
  }, [data]);

  return (
    <div className="wrapper">
      <MaterialTable
        title={null}
        data={data}
        columns={getColumns(filters, sourceType, reportType)}
        localization={localization}
        options={modifyDefaultOptions({
          search: false,
          draggable: false,
          toolbar: false,
          maxBodyHeight: 'calc(100vh - 376px)',
          filterCellStyle: {
            position: 'sticky',
            top: 79,
            background: 'white',
            zIndex: 5,
          },
        })}
        icons={tableIconsModified}
        components={{
          Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky} />),
          FilterRow: (props) => (<MTableFilterRow {...props} />),
          Body: (_props) => (
            <>
              <MTableBody {..._props} />
              <ProgramBuysFooter {..._props} />
            </>
          ),
        }}
      />
    </div>
  );
}

const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };
